const initialState = {
  privacyPolicy: null,
  isLoading: null,
  isError: null,
};

export default initialState;
